<!-- https://anjaneyasivan.github.io/v-suggestions/ -->

<template>
  <div class="v-suggestions">
    <input type="text" class="form-control" :class="extendedOptions.inputClass"
          :id="id"
           v-bind="$attrs"
           v-on:keydown="onKeyDown"
           v-on:blur="hideItems"
           v-on:focus="showResults"
           v-model="query"
           :placeholder="extendedOptions.placeholder"
           role="combobox"
           aria-autocomplete="both"
           aria-owns="id + '_results'"
           :aaaaria-haspopup="showItems"
           :aria-expanded="showItems"
           :aria-describedby="id + '_aria-descr'"
           />
      
      <ul class="typeahead dropdown-menu" v-if="showItems" role="listbox" :id="id + '_results'">

        <li 
            :key="index"
            v-for="(item, index) in items"
            @click.prevent="selectItem(index)"
            @mouseover="highlightItem(index)"
            v-bind:class="{ 'active': index === activeItemIndex }"
            role="presentation">
          <slot name="item"
                :item="item">
            <a role="option" href="#" :title="item">{{item}}</a>
          </slot>
        </li>
      </ul>

      <div :id="id + '_aria-descr'" class="sr-only">
        <span v-if="minLength > 1">Wpisz co najmniej {{minLength}} znaków</span>
        Po rozwinięciu użyj strzałek góra dół, aby zaznaczyć opcję
        Użyj klawisza enter, aby wybrać
      </div>

      <div aria-live="assertive" class="sr-only">
        {{ariaResults}}
      </div>

      
      
    
  </div>
</template>

<script>
  import debounce from 'debounce'

  

  export default {
    name: 'IcTypeahead',
    inheritAttributes: true,
    props: {
      id: {
        type: String,
        required: true
      },
      options: {
        type: Object,
        default: () => {
          return {}
        }
      },
      onInputChange: {
        type: Function,
        required: true
      },
      onItemSelected: {
        type: Function
      },
      getValue: {
        type: Function
      },
      getText: {
        type: Function
      },
      value: {
        type: String
      },
      text: {
        type: String
      },
      minLength: {
        type: Number,
        default: 3
      },
      selectFirst: {
        type: Boolean,
        default: false
      },
      autoSelect: {
        type: Boolean,
        default: true
      },
      ariaDD: {
        type: String,
        default: 'Wybierz stację używając strzałek góra/dół'
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    data () {
      const defaultOptions = {
        debounce: 0,
        placeholder: '',
        inputClass: 'input'
      }
      const extendedOptions = Object.assign({}, defaultOptions, this.options)
      return {
        extendedOptions,
        query: this.text || this.value,
        queryValue: this.value,
        lastSetQuery: null,
        items: [],
        selectedItem: null,
        activeItemIndex: -1,
        showItems: false,
        isSelected: false,
        ariaResults: ''
      }
    },
    computed: {
    },
    beforeMount () {
      if (this.extendedOptions.debounce !== 0) {
        this.onQueryChanged = debounce(this.onQueryChanged, this.extendedOptions.debounce)
      }
    },
    mounted() {
      // this.onQueryChanged(this.query)
    },
    watch: {
      'query': function (newValue, oldValue) {
        if (newValue === this.lastSetQuery) {
          this.lastSetQuery = null
          return
        }
        this.onQueryChanged(newValue)
        this.$emit('input', newValue)
      },
      'value': function (newValue, oldValue) {
        this.setQueryValue(newValue);
      },
      'text' : function(newValue) {
        this.setInputQuery(newValue);
      }
    },
    methods: {
      announceResults:
        debounce(function() {
          let s = "";
          if (this.isSelected ) {
            s = "Wybrano " + this.queryValue
          } else if (this.items.length > 0 && this.showItems && !this.loading) {
            s = "Znaleziono " + this.items.length + " wyników Pierwszy " + this.items[0].n;
          } else if (this.items.length === 0 && this.query.length >= this.minLength && !this.loading) {
            s = "Nic nie znaleziono"
          }
          this.ariaResults = s;
        },100),
      
      getTextDefault(item) {
        return item;
      },
      getValueDefault(item) {
        return item;
      },
      onItemSelectedDefault (item) {
        
        let value = typeof this.getValue === 'function' ? this.getValue(item) : this.getValueDefault(item)
        let text = typeof this.getText === 'function' ? this.getText(item) : this.getTextDefault(item)

        this.selectedItem = item
        this.$emit('input', value)
        this.$emit('update:text',text);
        this.$emit('update:item',item);
        this.setQueryValue(value)
        this.setInputQuery(text)
        
        // this.showItems = false
      },
      hideItems () {
        setTimeout(() => {
          this.showItems = false
          if (!this.isSelected && this.selectFirst) {
            let item = this.items[0]
            if (this.onItemSelected) {
              this.onItemSelected(item)
            } else {
              this.onItemSelectedDefault(item)
            }
          }
        }, 150)
      },
      showResults () {
        if (this.query.length >= this.minLength && this.items.length > 0 ) {
          this.showItems = true
        } else {
          this.showItems = false
        }
      },
      setQueryValue (value) {
        this.queryValue = value;
      },
      setInputQuery (value) {
        this.lastSetQuery = value
        this.query = value
      },
      onKeyDown (e) {
        this.showResults()
        switch (e.keyCode) {
          case 40:
            this.highlightItem('down')
            e.preventDefault()
            break
          case 38:
            this.highlightItem('up')
            e.preventDefault()
            break
          case 13:
            this.selectItem()
            e.preventDefault()
            break
          default:
            return true
        }
      },
      selectItem (index, hide) {
        let item = null
        hide = hide === false ? false : true
        this.isSelected = false;
        if (typeof index === 'undefined') {
          if (this.activeItemIndex === -1) {
            return
          }
          item = this.items[this.activeItemIndex]
        } else {
          item = this.items[index]
        }
        if (!item) {
          return
        }
        this.isSelected = true;
        if (this.onItemSelected) {
          this.onItemSelected(item)
        } else {
          this.onItemSelectedDefault(item)
        }
        if (hide) {
          this.hideItems()
        }
      },
      highlightItem (direction) {
        if (this.items.length === 0) {
          return
        }
        if (typeof direction === 'number') {
          this.activeItemIndex = direction
          return
        }
        let selectedIndex = this.items.findIndex((item, index) => {
          return index === this.activeItemIndex
        })
        if (selectedIndex === -1) {
          // nothing selected
          if (direction === 'down') {
            selectedIndex = 0
          } else {
            selectedIndex = this.items.length - 1
          }
        } else {
          this.activeIndexItem = 0
          if (direction === 'down') {
            selectedIndex++
            if (selectedIndex === this.items.length) {
              selectedIndex = 0
            }
          } else {
            selectedIndex--
            if (selectedIndex < 0) {
              selectedIndex = this.items.length - 1
            }
          }
        }
        this.activeItemIndex = selectedIndex
        if (this.autoSelect) {
          this.selectItem(this.activeItemIndex, false)
        }
      },
      setItems (items) {
        this.items = items
        this.activeItemIndex = -1
        this.showResults();
        this.announceResults();
      },
      onQueryChanged (value) {
        const result = this.onInputChange(value)
        // this.items = []
        if (typeof result === 'undefined' || typeof result === 'boolean' || result === null) {
          return
        }
        if (result instanceof Array) {
          this.setItems(result)
        } else if (typeof result.then === 'function') {
          result.then(items => {
            this.setItems(items)
          })
        }
      }
    },
    components: {
      
    }
  }
</script>

<style lang="scss">
.v-suggestions {
  position: relative;

  .typeahead.dropdown-menu {
    display: block;
    > li > a {
      font-size: 14px;
      line-height: 24px;
    }
  }
  .typeahead.dropdown-menu .active {
    background: #cacaca;
    color: inherit;
  }
  .typeahead.dropdown-menu .active a,
  .typeahead.dropdown-menu .active a:hover {
    color: inherit;
  }

}

$col-ic-highcontrast-text: #fff200;
$col-ic-highcontrast-input-bg: #3a3a3a;

#high-contrast {

  .v-suggestions {
    .form-control {
      color: $col-ic-highcontrast-text !important;
    }
    li.active {
      background: $col-ic-highcontrast-text;
      a {
        color: black !important;
      }
    }
  }
}

</style>